const interactionEvents = ['pointerdown', 'touchstart', 'keydown', 'scroll'];

export function runWhenBrowserIdle(task: () => void, timeout = 3000) {
  if (typeof window === 'undefined') {
    return;
  }

  const requestIdle = (window as any).requestIdleCallback;
  if (requestIdle) {
    requestIdle(task, {timeout});
    return;
  }

  setTimeout(task, Math.min(timeout, 1500));
}

function runOnFirstInteraction(task: () => void, delay?: number) {
  if (typeof window === 'undefined') {
    return () => {};
  }

  let done = false;
  let timer: ReturnType<typeof setTimeout> | null = null;
  const listenerOptions = {
    once: true,
    passive: true,
  } as AddEventListenerOptions;

  function cleanup() {
    interactionEvents.forEach(event => {
      window.removeEventListener(event, run, listenerOptions);
    });
    window.removeEventListener('load', scheduleDelay);
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function run() {
    if (done) {
      return;
    }
    done = true;
    cleanup();
    task();
  }

  function scheduleDelay() {
    if (typeof delay === 'number') {
      timer = setTimeout(run, delay);
    }
  }

  interactionEvents.forEach(event => {
    window.addEventListener(event, run, listenerOptions);
  });
  if (typeof delay === 'number') {
    if (document.readyState === 'complete') {
      scheduleDelay();
    } else {
      window.addEventListener('load', scheduleDelay, {once: true});
    }
  }

  return () => {
    done = true;
    cleanup();
  };
}

export function runAfterFirstInteraction(task: () => void) {
  return runOnFirstInteraction(task);
}

export function runAfterFirstInteractionOrDelay(
  task: () => void,
  delay = 15000,
) {
  return runOnFirstInteraction(task, delay);
}
